import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactImageMagnify from "react-image-magnify";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useStateContext } from "../contexts/ContextProvider";
import Ratings from "../subComponent/Ratings";
import { BsArrowLeft } from "react-icons/bs";
import { HiMinus, HiOutlinePlus } from "react-icons/hi";
import { AiFillCheckCircle } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CarouselContainer from "../subComponent/CarouselContainer";
import Footer from "./Footer";
const ItemDetails = () => {
  const { id, categ_id } = useParams();
  const [alteredDetail, setAlteredDetail] = useState([]);
  const [select, setSelect] = useState(1);
  const [alert, setAlert] = useState(false);
  const {
    setIsScrolled,
    itemDetail,
    setItemDetail,
    singleCategoryDetails,
    singleCategory,
    user,
    itemRating,
    setItemRating,
    setCartItem,
    cartItem,
    getCartFromLocalStorage,
  } = useStateContext();

  const navigate = useNavigate();

  useEffect(() => {
    setItemDetail("");
    singleItem(id);
    singleCategory(categ_id);
    window.scrollTo(0, 0);
    setSelect(1)
  }, [id]);

  useEffect(() => {
    changeItemRating();
    setAlteredDetail(itemDetail);
  }, [itemDetail]);

  // Function to update item rating
  const changeItemRating = () => {
    setItemRating(itemDetail.ratings);
  };

  // Function to fetch single item details
  const singleItem = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/item/${id}`)
      .then((res) => setItemDetail(res.data[0]));
  };

  // Function to handle adding items to the cart
  const handleCartItems = (productId) => {
    let cart = JSON.parse(localStorage.getItem("cartitems")) || [];
    let singleCategoryDetail = [];
    singleCategoryDetail.push(alteredDetail);
    let product = singleCategoryDetail.find(function (product) {
      return product.prod_id === productId;
    });

    if (cart.length === 0) {
      cart.push(product);
    } else {
      let res = cart.find((element) => element.prod_id === productId);
      if (res === undefined) {
        cart.push(product);
      }
    }

    localStorage.setItem("cartitems", JSON.stringify(cart));
    getCartFromLocalStorage();
    window.scrollTo(-20, 0);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 4000);
  };

  // Function to handle checkout
  const handleCheckout = () => {
    if (user) {
      let singleCart = [];
      singleCart.push(itemDetail);

      axios
        .post("https://matrix-api-h2bb.onrender.com/create-checkout-session", {
          cartitem: singleCart,
          customer_email: user.email,
          total_price: itemDetail.price,
          order_date: new Date().toISOString().slice(0, 19).replace("T", " "),
        })
        .then((res) => {
          if (res.data.url) {
            window.location.href = res.data.url;
          }
        })
        .catch((err) => console.log(err.message));
    } else {
      navigate("/login");
    }
  };

  window.onscroll = () => {
    // Check if the page is scrolled to the top
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  const handleQuantity = (productId, quantity) => {
    if (alteredDetail.prod_id === productId) {
      alteredDetail.quantity = quantity;
    }
  };

  const decrement = () => {
    if (select >= 2) {
      setSelect(select - 1);
      handleQuantity(itemDetail.prod_id, select - 1);
    } else {
      setSelect(1);
      handleQuantity(itemDetail.prod_id, select);
    }
  };

  const increment = () => {
    setSelect(select + 1);
    handleQuantity(itemDetail.prod_id, select + 1);
  };

  return (
    <Component>
      <ComponentWrapper>
        {alert && (
          <Alert>
            <AlertContainer>
              <div className="alert_wrapper">
                <AiFillCheckCircle /> Item Sucessfully Added
              </div>
              <div className="call_to_action">
                <button onClick={() => navigate(`/cart`)}>Go to cart</button>{" "}
                <button onClick={() => navigate(-1)}>Contine Shopping</button>
              </div>
            </AlertContainer>
          </Alert>
        )}

        {/* Back Button */}
        <Back onClick={() => navigate(-1)}>
          <BsArrowLeft style={{ marginRight: 7, fontSize: "14px" }} />
          <p style={{ fontSize: "11px" }}>back to previous category</p>
        </Back>

        {/* Image */}
        <Image>
          <ImageWrapper>
            {itemDetail?.image ? (
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: "Wristwatch by Ted Baker London",
                    isFluidWidth: true,
                    src: `${itemDetail?.image}`,
                  },
                  largeImage: {
                    src: `${itemDetail?.image}`,
                    width: 700,
                    height: 700,
                  },
                  isHintEnabled: true,
                  shouldHideHintAfterFirstActivation: false,
                  shouldUsePositiveSpaceLens: true,
                  fadeDurationInMs: 300,
                }}
              />
            ) : (
              <SkeletonWrapper>
                <Skeleton height={300} />
              </SkeletonWrapper>
            )}
          </ImageWrapper>
        </Image>

        {/* Description */}
        <Description>
          <h3>{itemDetail?.descr || <Skeleton count={4} />}</h3>
          <Rating>
            <p>{(itemRating && <Ratings />) || <Skeleton width={49} />}</p>{" "}
            <p style={{ color: "#491441" }}>
              {itemDetail?.ratings} / 5 star ratings
            </p>
          </Rating>
          <p>
            {" "}
            <span style={{ fontSize: "17px" }}> Price</span>: $
            {itemDetail?.price || <Skeleton width={49} />}{" "}
          </p>
        </Description>

        {/* Order */}
        <Order>
          <CartContainer>
            {itemDetail.price ? (
              <CartWrapper>
                <p style={{ marginTop: "0px" }}>
                  <sup style={{ fontSize: "14px" }}>$</sup>
                  <b style={{ fontSize: "27px" }}>
                    {itemDetail.price?.toString().split(".")[0]}
                  </b>
                  <sup style={{ fontSize: "14px" }}>
                    {itemDetail.price?.toString().split(".")[1]}
                  </sup>{" "}
                </p>
                <p style={{ marginTop: "0px" }}>
                  No import fees Deposit &<br /> ${33 + 10} shipping to Location{" "}
                </p>
                <p style={{ marginTop: "0px" }}>
                  Delivery Tuesday <br /> September 5.{" "}
                </p>
                <p style={{ marginTop: "0px" }}>
                  Or fastest delivery Monday, September 4
                </p>
                <h4 style={{ marginTop: "0px" }}>In Stock</h4>

                {/* Quantity */}
                <IncrementButtonWrapper>
                  <p>Qty</p>
                  <IncrementButton>
                    <button className="left" onClick={decrement}>
                      <HiMinus />
                    </button>
                    <div>{select}</div>
                    <button className="right" onClick={increment}>
                      <HiOutlinePlus />
                    </button>
                  </IncrementButton>
                </IncrementButtonWrapper>

                {/* Add to Cart Button */}
                <button
                  onClick={() => handleCartItems(itemDetail.prod_id)}
                  style={{
                    marginTop: "14px",
                    background: "pink",
                    cursor: "pointer",
                  }}
                >
                  Add to Cart
                </button>

                {/* Buy Now Button */}
                <button
                  className="buy-now"
                  onClick={handleCheckout}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  Buy Now
                </button>
              </CartWrapper>
            ) : (
              <Skeleton height={"70vh"} />
            )}
          </CartContainer>
        </Order>

        {/* Blur */}
      </ComponentWrapper>
      <SliderComponent>
        <CarouselContainer categ={categ_id} id={id} />
      </SliderComponent>
      <Blur></Blur>
      <FooterContainer>
        <Footer />
        <div className="buttom">
          <h1 className="Logo">
            Ma<span style={{ color: "pink" }}>t</span>rix
          </h1>
          <span>Built by Babzz</span>
        </div>
      </FooterContainer>

    </Component>
  );
};

export default ItemDetails;

const Component = styled.div`
  padding-top: 14vh;
  position: relative;
  display: flex;
  flex-direction: column;
 
`;

const ComponentWrapper = styled.div`
  margin-bottom: 0;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  overflow: hidden;
  @media (max-width: 470px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90vw;
    margin-bottom: 14vh;
    padding: 20px;
  }
`;

const SliderComponent = styled.div`
  width: 100vw;
  height: auto;
`;

const Image = styled.div`
  width: 40vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: 470px) {
    width: 90vw;
  }
`;

const ImageWrapper = styled.div`
  width: 70%;
  height: 70%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  img {
    object-fit: contain;
  }
  > div {
    max-width: 100%;
    max-height: 100%;
  }
  @media (max-width: 470px) {
    margin-top: 50px;
    width: 60%;
    height: 60%;
  }
`;

const Description = styled.div`
  width: 38vw;
  display: flex;
  flex-direction: column;

  h3 {
    text-transform: capitalize;
    letter-spacing: 1px;
    font-size: 21px;
    line-height: 27px;
    font-weight: 400;
    @media (max-width: 470px) {
      font-size: 17px;
    }
  }
  @media (max-width: 470px) {
    width: 90vw;
  }
`;

const FooterContainer = styled.div`
  margin-top: 20px;
  padding: 20px 80px;
  display: flex;
  flex-direction: column;
  background-color: #393636;
  color: white;
  @media (max-width: 470px) {
    padding: 5px 20px;
  }
  .buttom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .Logo {
    font-family: "Lobster", cursive;
    font-size: 44px;
    @media (max-width: 470px) {
      font-size: 24px;
    }
    cursor: pointer;

    a {
      text-decoration: none;
      color: black;
    }
  }
`;

const Order = styled.div`
  width: 20vw;

  @media (max-width: 470px) {
    width: 90vw;
  }
`;

const Rating = styled.div`
  display: flex;
  border-bottom: 1px solid #e1e1e1;
  position: relative;
  z-index: -1;
`;

const CartContainer = styled.div`
  margin: 10px;

  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(30px);
`;

const CartWrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  button {
    padding: 5px 0;
    margin-bottom: 4px;
    border-radius: 40px;
    border: 1px solid pink;
  }
  .buy-now {
    --color: #ad0b87;
    font-family: inherit;
    display: inline-block;
    padding: 5px 0;
    margin-bottom: 4px;
    border-radius: 40px;
    position: relative;
    overflow: hidden;
    border: 1px solid var(--color);
    transition: color 0.5s;
    z-index: 1;
    font-size: 12px;
    background-color: transparent;
    font-weight: 500;
    color: var(--color);
    &:before {
      content: "";
      position: absolute;
      z-index: -1;
      background: var(--color);
      height: 350px;
      width: 400px;
      border-radius: 50%;
    }

    &:hover {
      color: #fff;
    }
    &:before {
      top: 100%;
      left: 100%;
      transition: all 0.7s;
    }
    &:hover:before {
      top: -90px;
      left: -30px;
    }
    &:active:before {
      background: #3a0ca3;
      transition: background 0s;
    }
  }
  select {
    width: 34px;
    border: none;
    outline: none;
  }
  a {
    text-decoration: none;
    color: black;
  }
`;

const Blur = styled.div`
  position: absolute;
  width: 20rem;
  height: 14rem;
  border-radius: 50%;
  background: #ffd2fe;

  z-index: -1;
  filter: blur(84px);
  top: 20px;
  right: 1%;
  @media (max-width: 470px) {
    display: none;
  }
`;

const IncrementButton = styled.div`
  display: flex;
  width: 100px;
  border: 1px solid #f1c1c1;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  border-radius: 40px;
  transform: scale(0.6);
  div {
    transform: scale(1.6);
  }
  button {
    outline: none;
    border: 1px solid #717171;
    color: #f8f2f2;
    :hover {
      transform: scale(1.07);
    }
  }
  .left,
  .right {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #dc87d1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

const Back = styled.div`
  position: absolute;
  z-index: 4;
  top: 7;
  left: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: 470px) {
    top: -5px;
  }
`;

const IncrementButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const Alert = styled.div`
  position: absolute;
  top: 5px;
  width: 100%;
  z-index: 7000;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .alert_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    color: green;

    svg {
      font-size: 21px;
      margin-right: 10px;
    }
  }
  .call_to_action {
    width: 48%;
    display: flex;
    justify-content: space-between;
    @media (max-width: 470px) {
      width: 80%;
  }
     
    button {
      border: 1px solid #edc1e0;
      color: #801361;
      background: transparent;
      border-radius: 20px;
      padding: 4px 10px;
    }
  }
`;

const SkeletonWrapper = styled.div`
  width: 40vw;
  height: 40vh;
`;

const AlertContainer = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 470px) {
      width: 90%;
  }
  border: 1px solid #ecbbbb;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  backdrop-filter: blur(20px);
  padding: 4px 0;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.42);
  -webkit-box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.42);
  -moz-box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.42);
`;
